module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/sneakers.png?e4857afb53681c035140ae5e17fad328";